export default "__VITE_ASSET__B$YxZG6y__"